import { AttachmentApi } from '@api/twin/AttachmentApi';
import { MimeType } from '@stereograph/teia-system-design/components/DocumentViewer';
import { useTeiaViewerContext, useTwinSource } from '@stereograph/teiaviewer';
import { useQuery } from '@tanstack/react-query';
import { AnomalyDocument } from '../components/document/AnomalyDocumentCard';
import { anomalyQueryKeys } from '../query-keys';
import { getMimeType } from '../utils/useGetMimeType';

export interface DocumentViewerInterface {
  fileType: MimeType;
  filePath: string;
}

export const useGetAttachmentBlob = (attachment: AnomalyDocument) => {
  const { viewer: { twinApiClient }} = useTeiaViewerContext();
  const twin = useTwinSource();
  const attachmentApi = AttachmentApi(twinApiClient);

  return useQuery({
    queryKey: anomalyQueryKeys.visualize(attachment),
    queryFn: async () => {
      const response = await attachmentApi.download(twin.projectId, attachment.id);

      if (!response.ok) {
        console.error('api error');
      }

      const blob = await response.blob();

      const mimeType = getMimeType(attachment.title);

      const blobWithMimeType = blob.slice(0, blob.size, mimeType);

      return URL.createObjectURL(blobWithMimeType);
    },
    staleTime: Infinity,
    gcTime: 5 * 60 * 1000,
  });
};
